import { createContext, useContext } from 'react'

import { useProductState } from '../../hooks'

import type { ProductStateValue } from '../../hooks/product/useProductState'
import type { ProductProviderProps } from '../../types'

const ProductContext = createContext<ProductStateValue | undefined>(undefined)

/**
 * Thin Provider for product state
 * Calls useProductState composition hook
 */
export function ProductProvider({ children, productSku }: ProductProviderProps) {
  const value = useProductState(productSku)

  return <ProductContext value={value}>{children}</ProductContext>
}

export function useProduct() {
  const context = useContext(ProductContext)
  if (context === undefined) {
    throw new Error('useProduct must be used within a ProductProvider')
  }
  return context
}
